<template>
    <div>
        <List v-if="formStatus == 'list'" @addCallback="handleView"></List>
        <Edit v-if="formStatus == 'view'" :id="id" :item="item" :operate="operate" :page="page" @addCallback="handleView" @back="back"></Edit>
    </div>
</template>

<script>
    import List from "@/views/pd/budget/project/projectBudgetList";
    import Edit from "@/views/pd/budget/project/budgetEntry";
    export default {
        components: {List,Edit},
        data(){
            return {
                buttonPriviledgeList: [],
                formStatus:'list',
                id:null,
                status: 0,
                item: null,
                operate: null
            }
        },
        props: {
            page: {
                type: Object,
                default: null,
            }
        },
        created() {
          localStorage.removeItem('projectShopIds')
        },
        methods: {
            handleView(data) {
                console.log(data)
                this.formStatus = 'view';
                this.id = data.id;
                this.item = data.item;
                this.operate = data.operate
            },
            back() {
                this.formStatus = 'list';
            }
        }
    }
</script>

<style scoped>

</style>